<template lang="pug">
  .procedimentos-container
    modal-procedimentos(:openModal="modal", @close="closeModal", :edicao="procedimentosEdicao", @atualiza="atualizaLista")
    .sem-cadastro(v-if="!this.procedimentos.length") Nenhum procedimento cadastrado!
    ul.corpo-lista(v-else)
      li.lista(@click="abreModalEditar(list)", v-for="(list, a) in procedimentos", :key="a", :class="[list.status === 'I' ? 'inativo' : '']")
        .icn
          img(v-if="list.status === 'A'", src="../../assets/procedimentos.svg")
          img(v-else, src="../../assets/procedimentos-inativos.svg")
        .info
          .nome-procedimento {{ list.sigla }}
          .dados-procedimento {{ list.nome }} - {{ list.nome_especialidade }}
        .acao
          i(class="fa fa-pencil", aria-hidden="true")

    .paginacao(v-if="qtdProcedimento > 10")
      el-pagination(layout="prev, pager, next", prev-text="Anterior", next-text="Próximo", :total="Number(qtdProcedimento)", @current-change="handleCurrentChange")
</template>

<script>
import ModalProcedimentos from './ModalProcedimentos'
import Services from '../../utils/services'
import { mapGetters, mapMutations } from 'vuex'
import moment from 'moment'
moment.locale('pt-BR')

export default {
  components: { ModalProcedimentos },

  created() {
    this.getProcedimentos()
  },

  data: () => ({
    modal: false,
    procedimentos: [],
    qtdProcedimento: null,
    page: 0,
    size: 10,
    procedimentosEdicao: '',
  }),

  computed: {
    ...mapGetters(['getModal'])
  },

  watch: {
    getModal(){
      if(this.getModal === 'Procedimentos') this.abreModalCadastrar()
    }
  },

  methods: {
    ...mapMutations(['setLoad', 'setModal']),

    /* Método que lista os Procedimentos */
    async getProcedimentos(){
      this.setLoad(true)
      let auxListaProcedimento = await Services.get(`/procedimento/listar/${this.size}/pular/${this.page*10}`)
      this.qtdProcedimento = auxListaProcedimento.quantidade[0].quantidade
      this.procedimentos = auxListaProcedimento.lista
      if(this.procedimentos) this.setLoad(false)
    },

    /* Metodo que abre o modal de um novo cadastro */
    abreModalCadastrar(){
      this.modal = true
    },

    /* Metodo que abre o modal de edição */
    abreModalEditar(list) {
      this.modal = true
      this.procedimentosEdicao = list
    },

    /* Metodo que atualiza a lista de pacientes quando houver sucesso no cadastro ou edicao */
    atualizaLista(){
      this.getProcedimentos()
    },

    /* Metodo que fecha o modal */
    closeModal(){
      this.modal = false
      this.setModal('')
      this.procedimentosEdicao = ''
    },

    /* Metodo referente a paginacao */
    handleCurrentChange(val) {
      this.page = val - 1
      this.getProcedimentos()
    }
  }
}
</script>

<style lang="scss">
.procedimentos-container{
  width: 1100px;
  height: calc(100% - 120px);
  margin: 0 auto;
  overflow: auto;
  
  &::-webkit-scrollbar {
    display: none;
  }

  .sem-cadastro{
    margin-top: 100px;
    width: 90%;
    margin: 100px auto;
    height: 200px;
    background: rgb(245,245,245,.3);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: 300;
    color: red;
    box-shadow: 1px 3px 6px rgba(0,0,0,.3);
  }

  ul.corpo-lista{
    margin: 0;
    padding: 25px 0;
    box-sizing: border-box;

    li.lista{
      width: 100%;
      height: 85px;
      padding: 0 25px;
      margin-bottom: 15px;
      border: 1px solid #CBCBCB;
      border-radius: 10px;
      box-sizing: border-box;
      cursor: pointer;
      list-style: none;
      display: flex;
      align-items: center;
      justify-content: space-between;

      &.inativo{
        .info{
          .nome-procedimento{
            color: #666;
          }
          .dados-procedimento{
            color: #CBCBCB;
          }
        }
      }

      &:last-child{
        margin-bottom: 0;
      }

      .icn{
        margin-right: 25px;
      }

      .info{
        flex: 1;
        display: flex;
        height: 100%;
        flex-direction: column;
        justify-content: center;

        .nome-procedimento{
          font-size: 20px;
          color: #0180FF;
          font-weight: 400;
          margin-bottom: 2px;
          text-transform: uppercase;
        }
        .dados-procedimento{
          display: flex;
          font-size: 16px;
          color: #000;
          font-weight: 100;
        }
      }

      .acao{
        i{
          font-size: 26px;
          transform: rotate(-10deg);
          color: #0180FF;
        }
      }
    }
  }

  .paginacao{
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
  }
}
</style>